import routes from '@/constants/routes';
import { Tab, Tabs } from '@mui/material';
import { generatePath, Params, useNavigate, useParams } from 'react-router-dom';

const tabs = [
  {
    label: 'Publicados',
    value: 'publicados',
  },
  {
    label: 'Borradores',
    value: 'borradores',
  },
  {
    label: 'Archivados',
    value: 'archivados',
  },
];

const ContentTabs = () => {
  const navigate = useNavigate();
  const { organizationId, contentStatus } = useParams<Params>();

  return (
    <Tabs value={contentStatus}>
      {tabs.map((tab, index) => (
        <Tab
          key={`${tab}-${index}`}
          label={tab.label}
          value={tab.value}
          onClick={() =>
            organizationId
              ? navigate(
                  generatePath(routes.organizations.content.main, {
                    organizationId,
                    contentStatus: tab.value,
                  })
                )
              : null
          }
        />
      ))}
    </Tabs>
  );
};

export default ContentTabs;
